export default __webpack_public_path__ + "static/media/avatar.f0f31cbb.png";